.screen {
	min-height: 100%;
	display: grid;
	place-items: center;
	padding: var(--space-6);
	background:
		radial-gradient(
			circle at 20% 0%,
			color-mix(in oklab, var(--accent-apricot) 25%, transparent) 0%,
			transparent 45%
		),
		radial-gradient(
			circle at 100% 100%,
			color-mix(in oklab, var(--accent-sage) 25%, transparent) 0%,
			transparent 45%
		),
		var(--surface-page);
}

.card {
	width: min(420px, 100%);
	padding: var(--space-7) var(--space-6);
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	box-shadow: var(--shadow-card);
	display: grid;
	gap: var(--space-5);
}

.brand {
	display: flex;
	align-items: center;
	gap: var(--space-3);
}

.mark {
	width: 2.5rem;
	height: 2.5rem;
	border-radius: var(--radius-md);
	display: block;
}

.title {
	font-size: 1.75rem;
	font-weight: 600;
	margin: 0;
	letter-spacing: -0.01em;
}

.form {
	display: grid;
	gap: var(--space-4);
}

.segmented {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: var(--space-1);
	padding: var(--space-1);
	background: var(--surface-input);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
}

.segment {
	padding: var(--space-2) var(--space-3);
	border: none;
	border-radius: calc(var(--radius-md) - 2px);
	background: none;
	color: var(--ink-muted);
	font: inherit;
	font-size: 0.9rem;
	font-weight: 600;
	cursor: pointer;
	transition:
		background 0.15s ease,
		color 0.15s ease;
}

.segmentActive {
	background: var(--surface-card);
	color: var(--ink);
	box-shadow: var(--shadow-card);
}

/* Stacked "what are you here to do" cards on the first sign-in steps. */
.choices {
	display: grid;
	gap: var(--space-3);
}

.choice {
	display: grid;
	gap: var(--space-1);
	text-align: left;
	padding: var(--space-4);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	background: var(--surface-input);
	font: inherit;
	color: var(--ink);
	cursor: pointer;
	transition:
		border-color 0.15s ease,
		background 0.15s ease;
}

.choice:hover {
	border-color: var(--accent-sage);
	background: var(--surface-card);
}

.choice:focus-visible {
	outline: 2px solid var(--accent-sage);
	outline-offset: 2px;
}

.choiceTitle {
	font-weight: 600;
}

.choiceDesc {
	font-size: 0.85rem;
	line-height: 1.4;
	color: var(--ink-muted);
	text-wrap: pretty;
}

/* Doubled class on purpose: Field's `.field input` carries a type selector,
   so a single class loses to it and none of this would apply. */
.codeInput.codeInput {
	font-size: 1.5rem;
	letter-spacing: 0.5em;
	text-align: center;
	font-variant-numeric: tabular-nums;
}

.button {
	padding: var(--space-3) var(--space-5);
	border: none;
	border-radius: var(--radius-md);
	background: var(--accent-sage);
	color: white;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
	transition:
		transform 0.1s ease,
		background 0.15s ease;
}

.button:hover:not(:disabled) {
	background: color-mix(in oklab, var(--accent-sage) 88%, black);
}

.button:active:not(:disabled) {
	transform: translateY(1px);
}

.button:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.linkButton {
	background: none;
	border: none;
	padding: 0;
	color: var(--ink-muted);
	font: inherit;
	font-size: 0.9rem;
	cursor: pointer;
	text-decoration: underline;
	justify-self: center;
}

.linkButton:hover {
	color: var(--ink);
}

.hint {
	margin: 0;
	color: var(--ink-muted);
	font-size: 0.95rem;
}

.error {
	margin: 0;
	padding: var(--space-3) var(--space-4);
	background: color-mix(
		in oklab,
		var(--accent-rose) 20%,
		var(--surface-card)
	);
	color: color-mix(in oklab, var(--accent-rose) 70%, black);
	border-radius: var(--radius-md);
	font-size: 0.9rem;
}

/* "or" between the provider buttons and the email form, ruled either side. */
.divider {
	display: flex;
	align-items: center;
	gap: var(--space-3);
	margin: 0;
	color: var(--ink-muted);
	font-size: 0.85rem;
}

.divider::before,
.divider::after {
	content: '';
	flex: 1;
	border-top: 1px solid var(--border);
}
